import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class VehicleInfoAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "getManufacturersInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (onlyWithOnlineCars) => {
                return this.request('get', 'information/makers', { onlyWithOnlineCars })
                    .then((response => response.data));
            }
        });
        Object.defineProperty(this, "getYearsInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (makerId, modelId) => {
                const optionalParams = `${modelId ? `&modelId=${modelId}` : ''}`;
                return this.request('get', `information/years?maker_id=${makerId}${optionalParams}`)
                    .then((response => response.data));
            }
        });
        Object.defineProperty(this, "getModelsInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (makerId, year, month) => {
                const data = {
                    maker_id: makerId
                };
                if (year) {
                    data.year = year;
                }
                if (month) {
                    data.month = month;
                }
                return this.request('get', 'information/models', data)
                    .then((response => response.data));
            }
        });
        Object.defineProperty(this, "getModelsInfoByMaker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (maker, onlyWithOnlineCars) => this.request('get', 'information/models', { maker, onlyWithOnlineCars })
                .then((response => response.data))
        });
        Object.defineProperty(this, "getGeneralGroupedInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (query) => {
                return this.request('get', `information/general_grouped_information`, { ...query })
                    .then((response) => response.data);
            }
        });
        Object.defineProperty(this, "getModelVariantsInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (query) => this.request('get', `information/variants`, { ...query })
                .then((response) => response.data)
        });
        this.setConfig(config);
    }
}
export default new VehicleInfoAPI({
    baseURL: config.vehicleInfoAPI.url
});
